var Shopify = Shopify || {};

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = theme.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return(
      typeof opt == 'undefined'
        ? def
        : opt
    );
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1]
        ? (decimal + parts[1])
        : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount': value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

async function fetchMultipleRequests(data, url) {
  for (const data_item of data) {
    await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;'
      },
      body: JSON.stringify(data_item)
    }).then(response => response.json()).then(function(json) {

      // GTM Upsell subscription upgrade event
      dataLayer.push({ecommerce: null});
      dataLayer.push({
        event: 'upsell_subscription_upgrade',
        ecommerce: {
          items: json.items
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {

// Header scripts

  function set_element_height_into_variable(parent_container, element_to_measure, css_var_name) {
    height = $(element_to_measure).outerHeight(true);
    $(parent_container).css(`--${css_var_name}`, height + 'px');
  }

  if ($('.ch-announcement-bar-container').length) {
    set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
  }

  set_element_height_into_variable(':root', '.ch-container', 'header_height');

  $('body').removeClass('not-loaded');

  $(window).on('load', function() {
    set_element_height_into_variable(':root', '.ch-container', 'header_height');
    if ($('.ch-announcement-bar-container').length) {
      set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
    }

    if (window.location.hash) {
      setTimeout(function() {
        var scroll_to = $(window.location.hash).offset().top - $('.ch-container').outerHeight(true);

        if ($('.ch-announcement-bar-container').length) {
          scroll_to = scroll_to - $('.ch-announcement-bar-container').outerHeight(true);
        }

        $('html, body').animate({
          scrollTop: scroll_to
        }, 800);
      }, 1);
    }
  });

  $(window).on('resize', function() {
    if ($('.ch-announcement-bar-container').length) {
      set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
    };
    set_element_height_into_variable(':root', '.ch-container', 'header_height');
  });

  function check_current_scroll_position() {
    current_scroll = $(window).scrollTop();
    if (current_scroll > 0) {
      $('.ch-container').addClass('scrolled');
    } else {
      $('.ch-container').removeClass('scrolled');
    }
  }

  check_current_scroll_position();

  $(window).on('scroll', function() {
    check_current_scroll_position()
  });

  $(document).on('click', '[data-toggle-mobile-menu]', function() {
    $('.mobile-menu-container').toggleClass('opened');
    $('.ch-container').toggleClass('mobile-menu-opened');
    $('html').toggleClass('disable-scroll');
  });

// Footer scripts
  $(document).on('click', '[data-toggle-collapsible]', function(e) {
    e.preventDefault();
    collapsible_parent_container = $(this).parents('[data-collapsible-container]');
    $(this).toggleClass('opened');
    collapsible_parent_container.find('[data-collapsible-content]').slideToggle();
  });

// Banner slider
  if ($('.cbs-slider').length) {
    $('.cbs-slider').each(function() {
      if ($(this).hasClass('init-slider')) {
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        $(this).slick({
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed
        });
      }
    });
  }

// Insta slider
  if ($('.cis-slider').length) {
    $('.cis-slider').each(function() {
      if ($(this).hasClass('init-slider')) {
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        var wrapper = $(this).parent();
        var arrowPrev = wrapper.find('.cis-arrow-prev');
        var arrowNext = wrapper.find('.cis-arrow-next');
        $(this).slick({
          dots: false,
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          prevArrow: arrowPrev,
          nextArrow: arrowNext,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            }, {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false
              }
            }, {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
              }
            }
          ]
        });
      }
    });
  }

  if ($('.ct-slider').length) {
    $('.ct-slider').each(function() {
      if ($(this).hasClass('init-slider')) {
        $(this).slick({
          dots: true,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }, {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    });
  }

  if ($('.ci-ingredients-slider').length) {
    $('.ci-ingredients-slider').each(function() {
      var autoplay = $(this).data('autoplay');
      var autoplaySpeed = $(this).data('autoplay-speed');
      var arrows = $(this).data('arrows');
      if ($(this).hasClass('init-slider')) {
        $(this).slick({
          dots: false,
          arrows: arrows,
          slidesToShow: 4,
          slidesToScroll: 1,
          speed: 500,
          touchThreshold: 50,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          responsive: [
            {
              breakpoint: 2000,
              settings: {
                slidesToShow: 3
              }
            }, {
              breakpoint: 1600,
              settings: {
                slidesToShow: 2
              }
            }, {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1
              }
            }, {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    });
  }

// Product details

  if ($('.cpt-options-container').length) {
    variant_id = $('.cpt-form-select').val();
    filter_product_options_based_on_variant_id(variant_id);
  }

  

  function get_variants_with_same_options(option1, option2, option3) {
    product = JSON.parse($('#ProductJson').html());
    variantsMetafields = JSON.parse($('#VariantsMetafieldsJson').html());

    available_variants = product.variants.filter(variant => {
      const variantMetafields = variantsMetafields[variant.id];
      return variant.available == true && !variantMetafields.disabled;
    });

    variants_with_same_options = available_variants.filter(variant => {
      var will_return = false;
      if (variant.option1 && ! will_return) {
        will_return = variant.option1 == option1;
      }
      if (variant.option2 && ! will_return) {
        will_return = variant.option2 == option2;
      }
      if (variant.option3 && ! will_return) {
        will_return = variant.option3 == option3;
      }
      return will_return;
    });

    return variants_with_same_options;
  }

  function filter_product_options_based_on_variant_id(variant_id) {
    product = JSON.parse($('#ProductJson').html());
    variantsMetafields = JSON.parse($('#VariantsMetafieldsJson').html())

    current_variant = get_variant_by_id(variant_id);
    currentVariantMetafields = variantsMetafields[current_variant.id];

    available_options = {
      option1: [],
      option2: [],
      option3: []
    };

    variants_with_same_options = get_variants_with_same_options(current_variant.option1, current_variant.option2, current_variant.option3);

    for (i = 1; i <= product.options.length; i ++) {
      [...variants_with_same_options].forEach(variant => {
        available_options[`option${i}`].push(variant[`option${i}`]);
      });

    // Leaving only unique values
      available_options[`option${i}`] = [...new Set(available_options[`option${i}`])];
    }

    for (i = 1; i <= product.options.length; i ++) {
      $(`[data-option-index="option${i}"] .cpt-option`).each(function() {
        value = $(this).data('value').toString();
        if (i > 1) {
          if (available_options[`option${i}`].includes(value)) {
            $(this).prop('disabled', false);
          } else {
            $(this).prop('disabled', true);
          }
        }
      });
    }

    // Disable first options based on available variants
    $(`[data-option-index="option1"] .cpt-option`).each(function() {
      value = $(this).data('value').toString();
      available_variants = product.variants.filter((variant) => {
        const variantMetafields = variantsMetafields[variant.id];
        return variant.available && variant.option1 == value && !variantMetafields.disabled;
      });
      $(this).prop('disabled', !available_variants.length);
    })
  }

  $('.cpt-option').on('click', function() { 
    $(this).addClass('selected').siblings().removeClass('selected');
    new_value = $(this).data('value');
    
    option_container = $(this).parents('.cpt-option-container');
    option_container.find('.cpt-option-value').html(new_value);
    option_container.attr('data-current-value', new_value);
    update_main_selector();
  });

  function update_main_selector() {
    option_string = 'option';
    $('.cpt-option-container').each(function() { 
      option_string += `[data-${
        $(this).data('option-index')
      }="${
        $(this).attr('data-current-value')
      }"]`;
    });
    option = $('.cpt-form-select').find(option_string);
    if (option.length) {
      value = option.val();
      $('.cpt-form-select').val(value);
      var queryParams = new URLSearchParams(window.location.search);
      queryParams.set("variant", value);
      var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + queryParams.toString();
      window.history.replaceState({
        path: newUrl
      }, '', newUrl);
      update_add_to_cart_button($('.cpt-form-select'));
      filter_product_options_based_on_variant_id(value);
    } else {
      selected_variant_options = {};
      $('[data-option-index]').each(function() {
        selected_variant_options[`${
            $(this).attr('data-option-index')
          }`] = $(this).attr('data-current-value');
      });

      variants_with_same_options = get_variants_with_same_options(selected_variant_options.option1, selected_variant_options.option2, selected_variant_options.option3);

      similar_variants_by_option1 = variants_with_same_options.filter(variant => {
        return variant.option1 == selected_variant_options.option1;
      });

      if (similar_variants_by_option1.length) {
        first_similar_variant = similar_variants_by_option1[0];
        
        if (first_similar_variant.option2) {
          $(`[data-value="${
            first_similar_variant.option2
          }"]`).click();
        }

        if (first_similar_variant.option3) {
          $(`[data-value="${
            first_similar_variant.option3
          }"]`).click();
        }

      } else {
        $('.cpt-submit-button').addClass('unavailable');
        $('.cpt-submit-button').prop('disabled', true);
        $('.cpt-sb-text').html("Unavailable");
      }
    }
  }

  function update_add_to_cart_button(selector) {
    parent_section = selector.parents('.shopify-section');
    variantsMetafields = JSON.parse(parent_section.find('#VariantsMetafieldsJson').html());

    variantId = selector.val();
    variant = get_variant_by_id(variantId);
    variantMetafields = variantsMetafields[variant.id];
    

    hasDiscountCode = !!parent_section.find('[data-discount-value]').length;

    
    $('.cpt-submit-button').removeClass('unavailable');
    quantity_option_index = product.options.indexOf('Quantity') || product.options.indexOf('quantity');
    parent_section.find('[data-one-time-price]').html(Shopify.formatMoney(variant.price));
    
    if (hasDiscountCode) {
      discountCode = parent_section.find('[data-discount-code]').val();
      discountType = parent_section.find('[data-discount-type]').val();
      discountValue = parseFloat(parent_section.find('[data-discount-value]').val());
      if (discountType == 'percentage') {
        discountedOneTimePrice = variant.price * discountValue;
      } else {
        discountedOneTimePrice = variant.price - (discountValue * 100);
      }
      parent_section.find('[data-one-time-discounted-price]').html(Shopify.formatMoney(discountedOneTimePrice));
    }

    if (variant.compare_at_price > variant.price) {
      parent_section.find('[data-default-variant-compare-at-price]').html(Shopify.formatMoney(variant.compare_at_price));
      parent_section.find('[data-default-variant-compare-at-price]').show();
    } else {
      parent_section.find('[data-default-variant-compare-at-price]').hide();
    }

    if (quantity_option_index > -1) {
      quantity_option_value = parseInt(variant.options[quantity_option_index]);
      one_time_price_per_unit = variant.price / quantity_option_value;
  
      if (hasDiscountCode) {
        if (discountType == 'percentage') {
          discountedOneTimePricePerUnit = Math.ceil(one_time_price_per_unit * discountValue);
        } else {
          discountedOneTimePricePerUnit = Math.ceil((variant.price - (discountValue * 100)) / quantity_option_value);
        }
        one_time_price_per_unit = discountedOneTimePricePerUnit;
      }

      parent_section.css('--one-time-price-per-unit', `'${
        Shopify.formatMoney(one_time_price_per_unit)
      }'`);
      parent_section.find('[data-one-time-price-per-unit]').html( Shopify.formatMoney(one_time_price_per_unit));

      
      const el = document.querySelector('[data-automatic-discount-value]');
      const discountAmount = el ? el.getAttribute('data-automatic-discount-value') : null;
      discountedPriceAmount = 1 - discountAmount;

      if (variant.selling_plan_allocations.length) {
        subscription_plan_price = variant.selling_plan_allocations[0].price;
        subscription_plan_price_per_unit = subscription_plan_price / quantity_option_value;
        variant_price_per_unit = variant.price / quantity_option_value;

        if (hasDiscountCode) {
          if (discountType == 'percentage') {
            discountedSubscriptionPrice = subscription_plan_price * discountValue;
            discountedSubscriptionPricePerUnit = Math.ceil(subscription_plan_price_per_unit);
          } else {
            discountedSubscriptionPrice = subscription_plan_price - (discountValue * 100);
            discountedSubscriptionPricePerUnit = Math.ceil((discountedSubscriptionPrice - (discountValue * 100)) / quantity_option_value);
          }
          subscription_plan_price_per_unit = discountedSubscriptionPricePerUnit;
          current_plan_price_per_unit = discountedSubscriptionPricePerUnit;
          subscription_plan_price = discountedSubscriptionPrice;
        }

        const discountSum = subscription_plan_price * discountAmount;
        const trimmedDiscountSum = Math.floor(discountSum);

        //  const discountSum = Shopify.formatMoney(Math.round(subscription_plan_price * discountAmount));
        const formattedPrice = Shopify.formatMoney(Math.round(subscription_plan_price - trimmedDiscountSum));

        parent_section.css('--subscription-price-per-unit', `'${
          Shopify.formatMoney(subscription_plan_price_per_unit)
        }'`);
        parent_section.find('[data-subscription-price-per-unit]').html('<span>Only</span>' + ' ' + Shopify.formatMoney(subscription_plan_price_per_unit * discountedPriceAmount));
        // parent_section.find('[data-subscription-price]').html(Shopify.formatMoney(subscription_plan_price * discountedPriceAmount)); 
        
        parent_section.find('[data-subscription-price]').html(formattedPrice);

        parent_section.find('[data-disclamer-price]').html(Shopify.formatMoney(subscription_plan_price));  
        
        variant_title = variant.title;
      
        if (variant_title.includes("15") === true) {
          parent_section.find('[data-variant-price-per-unit]').html( Shopify.formatMoney(variant_price_per_unit));
          parent_section.find('[data-default-variant-price]').html(Shopify.formatMoney(variant.price));
          parent_section.find('[data-sub-title]').html('Subscribe & <span>Save 36%</span>');
          parent_section.find('[data-sub-text]').addClass('subscription-additional-html-new');
        } else if (variant_title.includes("30") === true) {
          parent_section.find('[data-variant-price-per-unit]').html('$3.99');
          parent_section.find('[data-default-variant-price]').text('$119.70');
          parent_section.find('[data-sub-title]').html('Subscribe & <span>Save 48%</span>');
          parent_section.find('[data-sub-text]').removeClass('subscription-additional-html-new ');
        } else if (variant_title.includes("60") === true) {
          parent_section.find('[data-variant-price-per-unit]').html('$3.99');
          parent_section.find('[data-default-variant-price]').html('$239.40');
          parent_section.find('[data-sub-title]').html('Subscribe & <span>Save 52%</span>');
          parent_section.find('[data-sub-text]').removeClass('subscription-additional-html-new ');
        }
      }      
    }
    if (variant.available && !variantMetafields.disabled) {
      $('.cpt-submit-button').prop('disabled', false);
      $('.cpt-sb-text').html(theme.strings.addToCart);
    } else {
      $('.cpt-submit-button').prop('disabled', true);
      $('.cpt-sb-text').html(theme.strings.soldOut);
    }
    if (variant.featured_media) {
      media_id = variant.featured_media.id;
      media_alt = variant.featured_media.alt || product.title;
      $('[data-thumbnail]').addClass('hidden');
      $(`[data-thumbnail-media-alt="${media_alt}"]`).removeClass('hidden');
      thumbnail = $(`[data-thumbnail-media-id='${media_id}']`);
      if (thumbnail.length) {
        thumbnail.addClass('active').siblings().removeClass('active');
        filter_main_images_slides(media_alt, $('.cpt-main-images-wrapper').slick('getSlick'));
        slide_index = $(`[data-main-media-id="${media_id}"]`).index();
        $('.cpt-main-images-wrapper').slick('slickGoTo', slide_index);
      }
    }

  }

  function get_variant_by_id(variant_id) {
    var product = JSON.parse($('#ProductJson').html());
    var result = product.variants.filter(obj => {
      return obj.id == variant_id;
    });
    var variant = result[0];
    return variant;
  }

  function filter_main_images_slides(media_alt, slick) {
    slick.unfilterSlides();
    slick.filterSlides(`[data-media-alt="${media_alt}"]`);
    width = 100 / slick.slideCount + '%';
    progress = (100 / slick.slideCount) * (slick.currentSlide + slick.options.slidesToShow) + '%';
    $('.cpt-main-images-progress-bar').css({"--progress": progress, "--width": width});
  }


  $('.cpt-main-images-wrapper').on('init', function(event, slick) {
    product = JSON.parse($('#ProductJson').html());
    variant_id = $('.cpt-form-select').val();
    variant = get_variant_by_id(variant_id);
    media_alt = variant?.featured_media?.alt || product.title;
    filter_main_images_slides(media_alt, slick);
  });

  $('.cpt-main-images-wrapper').slick({
    infinite: false,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.cpt-main-images-wrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    width = 100 / slick.slideCount + '%';
    progress = (100 / slick.slideCount) * (nextSlide + 1) + '%';
    $('.cpt-main-images-progress-bar').css({"--progress": progress, "--width": width});
    media_id = $(slick.$slides[nextSlide]).data('main-media-id');
    $(`[data-thumbnail-media-id="${media_id}"]`).addClass('active').siblings().removeClass('active');
  });

  $('[data-thumbnail-media-id]').on('click', function() {
    $(this).addClass('active').siblings().removeClass('active');
    media_id = $(this).data('thumbnail-media-id');
    slide_index = $(`[data-main-media-id="${media_id}"]`).index();
    $('.cpt-main-images-wrapper').slick('slickGoTo', slide_index);
  });

  $(document).on('click', '[data-toggle-popup]', function(e) {
    e.preventDefault();
    popup = $(`[data-popup="${
      $(this).data('toggle-popup')
    }"]`);
    popup.fadeToggle().toggleClass('opened');
    $('html').toggleClass('disable-scroll');
  });

  $(document).on('click', '.cpt-popup-container', function(e) {
    if (!$(e.target).parents('.cpt-popup-content').length) {
      $('.cpt-popup-container').fadeToggle().toggleClass('opened');
      $('html').toggleClass('disable-scroll');
    }
  });


// FAQ Page
  if ($('.custom-faq-page-faq-section').length) {
    $(document).on('click', '.fp-cpi-block', function() {
      category = $(this).data('category');
      $('.fp-cpi-block').removeClass('active');
      $('.fp-cpf-container').removeClass('visible');
      $(this).addClass('active');
      $('.fp-cpf-container[data-category="' + category + '"]').addClass('visible');
      $('html,body').animate({
        scrollTop: $('.fp-cpf-container[data-category="' + category + '"]').offset().top - $('.custom-header-section').outerHeight(true)
      }, 'slow');
    });
  }

// Buttons
  

// Text with slider
  if ($('.cptwls-slider').length) {
    $('.cptwls-slider').each(function() {
      if ($(this).hasClass('init-slider')) {
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        $(this).slick({
          dots: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "90px",
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          mobileFirst: true,
          infinite: true,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
                slidesToSroll: 1,
                centerPadding: "0px",
                centerMode: true
              }
            }
          ]
        });

        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          if (currentSlide != nextSlide) {
            test_slider = $(this).parent().find('.cptwls-text-slider');
            test_slider.find('.cptwls-text').hide();
            test_slider.find('.cptwls-text[data-block-id="' + nextSlide + '"]').fadeIn(500);
          }
        });
      }
    });
  }

  $(document).on('click', '[data-change-quantity]', function(e) {
    e.preventDefault();
    quantity_change = parseInt($(this).data('change-quantity'));
    quantity_input = $(this).parents('form').find('[name="quantity"]');
    if (!quantity_input.length) {
      quantity_input = $(this).parent().find('[name="updates[]"]');
    }
    current_quantity = parseInt(quantity_input.val());
    new_quantity = current_quantity + quantity_change;
    quantity_input.val(new_quantity).trigger('change');
    $(this).parent().find('[data-current-quantity]').html(new_quantity);
  });

  // AJAX cart

  if ($('#shopify-section-custom-cart-drawer').length) {
    $(document).on('submit', '[data-enable-cart-drawer="true"] form[action="/cart/add"]', function(e) {
      e.preventDefault();
      const form = this;
      const clearCart = form.dataset.clearCart == 'true';
      if (clearCart) {
        fetch(theme.cartRoutes.cartClearUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;'
          }
        }).then(function(response) {
          return response.json();
        }).then(function(json) {
          if (json.status && json.status !== 200) {
            var error = new Error(json.description);
            error.isFromServer = true;
            throw error;
          }
          addItemToCart(form);
        }).catch(function(error) {
          console.log(error);
        });
      } else {
        addItemToCart(this);
      }
    });

    $(document).on('click', '[data-toggle-cart-drawer]', function(e) {
      e.preventDefault();
      $('html').toggleClass('disable-scroll cart-drawer-opened');
    });

    $(document).on('click', '[data-remove-item]', function(e) {
      e.preventDefault();
      item_key = $(this).data('remove-item');
      updateCartItem(item_key, 0);
    });

    $(document).on('change', '[data-change-item-quantity]', function(e) {
      quantity = $(this).val();
      item_key = $(this).data('change-item-quantity');
      updateCartItem(item_key, quantity);
    });

    function updateCartItem(key, quantity) {
      let updates = {};
      updates[key] = quantity;
      fetch(theme.cartRoutes.cartUpdateUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({updates})
      }).then(function(response) {
        return response.json();
      }).then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        renderCartDrawer();
      }).catch(function(error) {

       // eslint-disable-next-line no-console
        console.log(error);
      });
    }

    function addItemToCart(form) {
      const redirectToCheckout = form.dataset.redirectToCheckout == 'true';
      let redirectUrl = '/checkout';

      if (!!form.querySelector('[data-discount-code]')) {
        const discountCode = form.querySelector('[data-discount-code]').value;
        redirectUrl += '?discount=' + discountCode;
      }

      const formData = new FormData(form);
      const discountCodeInput = form.querySelector('[data-discount-code]');
      const discountCode = discountCodeInput ? discountCodeInput.value.toLowerCase() : 'true';
      formData.append('properties[_discount]', discountCode);

      fetch(theme.cartRoutes.cartAddUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams(formData)
      })
      .then(response => response.json())
      .then(json => {
        if (json.status && json.status !== 200) {
          const error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }

        var item = {
          Name: json.title,
          ProductID: json.product_id,
          ImageURL: json.image,
          URL: `${window.location.origin}${json.url}`,
          Brand: json.vendor,
          Price: Shopify.formatMoney(json.price)
        };
        _learnq.push(['track', 'Added to Cart', item]);

        if (redirectToCheckout) {
          window.location.href = redirectUrl;
        } else {
          renderCartDrawer();
          openCartDrawer();
        }
      })
      .catch(function(error) {
        console.log(error);
      });
    }

    function openCartDrawer() {
      $('html').addClass('disable-scroll cart-drawer-opened');
    }

    function renderCartDrawer() {
      var time = Date.now();
      fetch(`/?section_id=custom-cart-drawer&timestamp=${time}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function(response) {
        return response.text();
      }).then(function(text) {
        text_to_html = $.parseHTML(text.replaceAll('\x3C!-- BEGIN static -->', '').replaceAll('\x3C!-- END static -->', ''));
        section_content = $(text_to_html).html();
        $('#shopify-section-custom-cart-drawer').html(section_content);
        new_cart_count = parseInt($('#shopify-section-custom-cart-drawer [data-current-cart-count]').data('current-cart-count'));
        if (new_cart_count > 0) {
          $('.ch-cart-link').addClass('not-empty');
        } else {
          $('.ch-cart-link').removeClass('not-empty');
        }
        $('[data-cart-count]').html(new_cart_count);
      });
    }

    $(document).on('change', '[name="subscription-switch"]', function() {
      input = $(this)[0];
      input.setAttribute('disabled', 'disabled');
      data_array = [];
      $('.ccds-container').attr('loading', '');
      if ($(this)[0].checked) { // Turn all applicable products to subscription
        $('.ccds-item[data-cart-item-is-subscription="false"][data-cart-item-has-subscription-plans="true"]').each((index, item) => {
          data = {
            line: parseInt(item.dataset.cartItemIndex),
            quantity: parseInt(item.dataset.cartItemQuantity),
            selling_plan: parseInt(item.dataset.cartItemFirstSubscriptionPlanId)
          }
          data_array.push(data);
        });
      } else { // Turn all applicable products to one-time purchase
        $('.ccds-item[data-cart-item-is-subscription="true"][data-cart-item-has-subscription-plans="true"]').each((index, item) => {
          data = {
            line: parseInt(item.dataset.cartItemIndex),
            quantity: parseInt(item.dataset.cartItemQuantity),
            selling_plan: null
          }
          data_array.push(data);
        });
      } fetchMultipleRequests(data_array, theme.cartRoutes.cartChangeUrl + '.js').then((allResponses) => {
        renderCartDrawer();
      }).catch(error => {
        console.log(error);
      })
    });

    $(document).on('submit', '[data-cart-drawer-upsell-form]', function(e) {
      e.preventDefault();
      $('.ccds-container').attr('loading', '');
      baseItemKey = this.dataset.baseItemKey;
    
      let updates = {};
      updates[baseItemKey] = 0;
    
      fetch(theme.cartRoutes.cartUpdateUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => response.json())
      .then(json => {
        if (json.status && json.status !== 200) {
          throw new Error(json.description);
        }
    
        let hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'properties[_upsell]';
        hiddenInput.value = 'true';
        e.target.appendChild(hiddenInput); 
    
        let formData = theme.Helpers.serialize(e.target);
    
        return fetch(theme.cartRoutes.cartAddUrl + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
      })
      .then(response => response.json())
      .then(json => {
        if (json.status && json.status !== 200) {
          throw new Error(json.description);
        }
    
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: 'upsell_upgrade',
          ecommerce: {
            items: [
              {
                item_id: json.id, 
                item_name: json.title,
                item_brand: json.vendor,
                item_variant: json.id,
                currency: Shopify.currency.active,
                price: json.price / 100
              }
            ]
          }
        });
    
        renderCartDrawer();
      })
      .catch(error => {
        console.error("Error:", error);
      });
    });

  }



  // CART DISCOUNT

    const cartContainer = document.querySelector('#shopify-section-custom-cart-drawer');

    if (cartContainer) {
      const observer = new MutationObserver(() => {
        observer.disconnect(); 
        calculateDiscount();
        observer.observe(cartContainer, {
          childList: true,
          subtree: true
        }); 
      });

      observer.observe(cartContainer, {
        childList: true,
        subtree: true
      });

      calculateDiscount();
    }

    function calculateDiscount() {
      let lineItems = document.querySelectorAll('[data-variant-old-price]');
      let oldTotal = 0;

      lineItems.forEach(item => {
        let oldPrice = parseFloat(item.getAttribute('data-variant-old-price')) || 0;
        let quantity = parseInt(item.getAttribute('data-cart-item-quantity')) || 0;
        oldTotal += oldPrice * quantity;
      });

      let cartTotalEl = document.querySelector('[data-cart-total-price]');
      let cartTotal = 0;

      if (cartTotalEl) {
        cartTotal = parseFloat(cartTotalEl.getAttribute('data-cart-total-price')) || 0;
      }

      let discount = Math.max(0, oldTotal - cartTotal) / 100;

      let discountEl = document.querySelector('[data-alternative-cart-discount]');
      if (discountEl) {
        discountEl.textContent = `$${discount.toFixed(2)}`;
      }

      let cartSubtotalEl = document.querySelector('[data-cart-subtotal-price]');
      let oldTotalSum = Math.max(0, oldTotal) / 100;

      if (cartSubtotalEl) {
        cartSubtotalEl.textContent = `$${oldTotalSum.toFixed(2)}`;
      }
    }

});

class FloatingCTAButton extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      anchor: this.querySelector('[data-anchor]'),
      floatingContainer: this.querySelector('[data-floating-container]'),
      clickATCButton: this.querySelector('[data-click-atc-button]'),
    }

    if (this.elements.clickATCButton) {
      this.elements.clickATCButton.addEventListener('click', this.handleATCButtonClick.bind(this));
    }
  }

  handleScroll(event) {
    const anchorTopPosition = this.elements.anchor.offsetTop;
    const windowScrollY = window.scrollY;
    this.elements.floatingContainer.setAttribute('aria-hidden', !(windowScrollY > anchorTopPosition));
  }

  handleATCButtonClick(event) {
    event.preventDefault();
    const ATCButton = document.querySelector('.cpt-submit-button');
    if (ATCButton) {
      ATCButton.click();
    }
  }

  connectedCallback() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }
}

customElements.define('floating-cta-button', FloatingCTAButton);

class IngredientsWithTabs extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      tabs: this.querySelectorAll('[data-tab]'),
      tiedToTab: this.querySelectorAll('[data-tied-to-tab]'),
    }

    if (this.elements.tabs.length) {
      this.elements.tabs.forEach(
        (tab) => tab.addEventListener('click', this.handleTabClick.bind(this))
      );
    }
  }

  handleTabClick(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;

    this.elements.tabs.forEach(
      (tab) => tab.setAttribute('aria-active', false)
    );

    clickedTab.setAttribute('aria-active', true);

    this.elements.tiedToTab.forEach((tiedToTab) => {
      const relatedTabsArray = JSON.parse(tiedToTab.querySelector('[data-related-tabs-json]').innerHTML);
      
      relatedTabsArray.forEach((item, index) => {
        relatedTabsArray[index] = item.replaceAll('\n','');
      });
      tiedToTab.setAttribute('aria-active', relatedTabsArray.includes(clickedTab.id));
    });
  }

  connectedCallback() {
    if(window.location.search && this.elements.tabs.length) {
      const params = new URL(location.href).searchParams;
      const tabIdFromParams = params.get('tab');
      if (tabIdFromParams) {
        this.elements.tabs.forEach(
          (tab) => {
            if (tab.id == tabIdFromParams) {
              tab.click();
            }
          }
        )
      }
      
    }
  }
}

customElements.define('ingredients-with-tabs', IngredientsWithTabs);